import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Container } from "react-bootstrap";
import bandeauInGovernanceDefault from "../../assets/images/bandeauInGovernanceDefault.jpg";
import bandeauInOperationDefault from "../../assets/images/bandeauInOperationDefault.jpg";
import bandeauEspacesDefault from "../../assets/images/bandeauEspacesDefault.jpg";
import bandeauInSocialDefault from "../../assets/images/bandeauInSocialDefault.jpg";
import bandeauInViewsDefault from "../../assets/images/bandeauInViewsDefault.jpg";

import bandeauInGovernanceChrono from "../../assets/images/bandeauInGovernanceChrono.jpg";
import bandeauInSocialChrono from "../../assets/images/bandeauInSocialChrono.jpg";
import bandeauInViewsChrono from "../../assets/images/bandeauInViewsChrono.jpg";
import bandeauEspacesChrono from "../../assets/images/bandeauEspacesChrono.jpg";

const ComponentBandeau = (props) => {
  const { menu, isCalendarView } = props;
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const [bandeau, setBandeau] = useState("");

  useEffect(() => {
    switch (menu) {
      case "inGovernance":
        if (isCalendarView) {
          ReduxInstance.governancePicChrono
            ? setBandeau(
                process.env.REACT_APP_URL_EXPRESS +
                  "images/instance/" +
                  ReduxInstance.governancePicChrono
              )
            : setBandeau(bandeauInGovernanceChrono);
        } else {
          ReduxInstance.governancePic
            ? setBandeau(
                process.env.REACT_APP_URL_EXPRESS + "images/instance/" + ReduxInstance.governancePic
              )
            : setBandeau(bandeauInGovernanceDefault);
        }
        break;
      case "inSocial":
        if (isCalendarView) {
          ReduxInstance.socialPicChrono
            ? setBandeau(
                process.env.REACT_APP_URL_EXPRESS +
                  "images/instance/" +
                  ReduxInstance.socialPicChrono
              )
            : setBandeau(bandeauInSocialChrono);
        } else {
          ReduxInstance.socialPic
            ? setBandeau(
                process.env.REACT_APP_URL_EXPRESS + "images/instance/" + ReduxInstance.socialPic
              )
            : setBandeau(bandeauInSocialDefault);
        }

        break;
      case "inOperation":
        ReduxInstance.operationPic
          ? setBandeau(
              process.env.REACT_APP_URL_EXPRESS + "images/instance/" + ReduxInstance.operationPic
            )
          : setBandeau(bandeauInOperationDefault);
        break;
      case "inViews":
        if (isCalendarView) {
          ReduxInstance.viewsPicChrono
            ? setBandeau(
                process.env.REACT_APP_URL_EXPRESS +
                  "images/instance/" +
                  ReduxInstance.viewsPicChrono
              )
            : setBandeau(bandeauInViewsChrono);
        } else {
          ReduxInstance.viewsPic
            ? setBandeau(
                process.env.REACT_APP_URL_EXPRESS + "images/instance/" + ReduxInstance.viewsPic
              )
            : setBandeau(bandeauInViewsDefault);
        }
        break;
      case "espaces":
        if (isCalendarView) {
          ReduxInstance.espacePicChrono
            ? setBandeau(
                process.env.REACT_APP_URL_EXPRESS +
                  "images/instance/" +
                  ReduxInstance.espacePicChrono
              )
            : setBandeau(bandeauEspacesChrono);
        } else {
          ReduxInstance.espacePic
            ? setBandeau(
                process.env.REACT_APP_URL_EXPRESS + "images/instance/" + ReduxInstance.espacePic
              )
            : setBandeau(bandeauEspacesDefault);
        }
        break;
      default:
        console.log("souci pas d'images");
    }
  }, [isCalendarView, ReduxInstance]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Container
      fluid
      className={
        isCalendarView ? "bandeauPage declinaisonChrono" : "bandeauPage declinaisonCategorie"
      }
      style={{ backgroundImage: `url(${bandeau})` }}
    ></Container>
  );
};

export default ComponentBandeau;
